/* eslint-disable no-unused-vars */
// @ts-ignore
import { getCurrentPosition, addressToGeoCode } from '@mtfe/mars-webloc/es';
// @ts-ignore
import BExt from '@cap/bext';
import { isMeiTuan, isMMP, isWXMiniProgram } from '@cap/utils';
import axios from 'axios';
import { isBrowser } from '@cap/ssr-common-utils';
import { logger, formatErrorToString } from '../logger';
import pkg from '../../../package.json';
import { ILocateResult } from './types';

export * from './types';

const { webloc: pkgWebloc } = pkg;
const defaultConfig = {
  project: 'webloc',
  ...pkgWebloc,
  city: true,
  KNBCache: true,
  disable: ['html'],
  timeout: 10 * 1000,
};

interface MPLocation {
  latitude: string;
  longitude: string;
  speed: number;
  accuracy: string;
}

/**
 * 小程序中获取用户定位和城市信息
 * @returns
 */
async function getMPPosition(): Promise<ILocateResult | null> {
  return new Promise(async (resolve) => {
    if (!isBrowser) {
      return resolve(null);
    }
    const { userAgent } = navigator;
    if (isMMP(userAgent) || isWXMiniProgram(userAgent)) {
      BExt.ready(() => {
        const geotype = 'wgs84';
        window.wx.getLocation({
          type: geotype,
          _mt: {
            /**
             * 隐私合规参数
             * @see https://km.sankuai.com/page/1219328972#id-3.2.1%E5%AE%9A%E4%BD%8D
             * @see https://km.sankuai.com/docs/mmp/page/1007592192
             * @see https://privacy.sankuai.com/register/list?businessKey=jcyf&page=current-4_pageSize-20
             */
            sceneToken: 'jcyf-c5d97f2cf5534bdf',
          },
          success: async (res: MPLocation) => {
            const { latitude, longitude, accuracy } = res;
            logger.log('MPLocation', res);
            // geo 反编码
            const { data: { status, regeocode } = {}, status: httpStatus } = await axios
              .create()
              .get(`https://lbsapi.meituan.com/v1/location/regeo`, {
                params: {
                  key: 'm884591e598848578cdfb6daedb9420w',
                  location: `${longitude},${latitude}`,
                  show_fields: 'base|admin',
                  limit: 2,
                },
              });
            if (httpStatus === 200 && status === 200) {
              const [city] = regeocode;
              return resolve({
                city,
                geo: {
                  latitude, // 纬度
                  longitude, // 经度
                  accuracy, // 精确度
                  geotype, // 定位类型
                },
              });
            }
            resolve(null);
          },
          fail: (err: Error) => {
            logger.warn({ name: 'mplocation', msg: formatErrorToString(err) });
            resolve(null);
          },
        });
      });
      return;
    }
    resolve(null);
  });
}

export const webloc = {
  /**
   * 当前设备定位数据
   * @param userid
   * @param uuid
   * @returns
   */
  async getCurrentPosition(customConfig = {}): Promise<ILocateResult | null> {
    const config = {
      ...defaultConfig,
      ...customConfig,
    };
    return new Promise(async (resolve) => {
      if (!isBrowser) {
        // todo: 服务端通过ip进行定位
        return resolve(null);
      }
      const loc = await getMPPosition();
      if (loc) {
        return resolve(loc);
      }
      // eslint-disable-next-line consistent-return
      getCurrentPosition(config, (err: Error, result: any) => {
        if (err) {
          // 定位失败
          return resolve(null);
        }
        resolve(result);
      });
    });
  },
  /**
   * 获取用户的定位数据（仅美团App下能获取用户自己选择的城市信息，其他环境获取设备的定位数据）
   * @param param0
   * @returns
   */
  async locate(customConfig = {}): Promise<ILocateResult> {
    const positionPromise = webloc.getCurrentPosition(customConfig);

    // eslint-disable-next-line consistent-return
    const cityPromise = new Promise((resolve) => {
      if (!isBrowser) {
        // todo: 服务端通过ip获取定位
        return resolve(null);
      }
      if (!isMeiTuan(navigator.userAgent)) {
        return resolve(null);
      }
      BExt.ready(() => {
        BExt.getCity({
          // @ts-ignore
          success(city) {
            const { cityId, cityName, adcode } = city;
            addressToGeoCode(
              {
                address: cityName,
                key: 'm884591e598848578cdfb6daedb9420w',
                // eslint-disable-next-line consistent-return
                // @ts-ignore
              },
              // @ts-ignore
              (err: Error, res) => {
                if (err || !res?.result[0]) {
                  return resolve(null);
                }
                // eslint-disable-next-line no-unsafe-optional-chaining
                const { location } = res?.result[0];
                const [longitude, latitude] = location.split(',');
                resolve({
                  city: {
                    id: cityId,
                    city: cityName,
                    adcode,
                  },
                  geo: {
                    longitude,
                    latitude,
                  },
                });
              },
            );
          },
          fail() {
            return resolve(null);
          },
        });
      });
    });

    const results = await Promise.all([positionPromise, cityPromise]);
    const [current, selected] = results;
    if (current && selected) {
      // @ts-ignore
      if (current.city.id === selected.city.id) {
        return current;
      }
      return selected as ILocateResult;
    }
    if (!current && selected) {
      return selected as ILocateResult;
    }
    if (current && !selected) {
      return current;
    }
    return Promise.reject(new Error('定位失败'));
  },
};
